import { useState } from "react";
import { saveExternalSystem } from "../Api/ExternalSystem";
import { Container, Form, Button, Row, Col } from "react-bootstrap";

import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Sample14 from "../Components/Logo";

const ExternalSystem = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const userName = localStorage.getItem("username") || "defaultUser";

  const [externalSystemData, setExternalSystemData] = useState({
    externalCode: "",
    description: "",
  });

  const handleChange = (e) => {
    setExternalSystemData({ ...externalSystemData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await saveExternalSystem(externalSystemData, userName);
      toast.success("🦄 External System Added Successfully");
      setExternalSystemData({
        externalCode: "",
        description: "",
      });
    } catch (error) {
      toast.error("🦄 Some Error Happened");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      
        <div className="main-content expand">
          <Container fluid className="fields-container">
            <h2 className="fields-title">External System</h2>

            <Form onSubmit={handleSubmit} className="fields-form">
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>External Code <span className="text-red">**</span></Form.Label>
                    <Form.Control
                      type="text"
                      name="externalCode"
                      value={externalSystemData.externalCode}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Description <span className="text-red">**</span></Form.Label>
                    <Form.Control
                      type="text"
                      name="description"
                      value={externalSystemData.description}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
              </Row>

              <div className="fields-btn-container">
                <Button variant="primary" type="submit" className="fields-submit">
                  Save External System
                </Button>
              </div>
            </Form>
          </Container>
        </div>
      

      {loading && (
        <div className="loading-overlay">
          <Sample14 />
        </div>
      )}
    </>
  );
};

export default ExternalSystem;